export default __webpack_public_path__ + "assets/streak_badge-8aeaffdd4aa3357fa3793aac35730e51.png";